module.exports = __webpack_public_path__ + "img/ls_type_ac.64275c0e.png";